import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import CircularProgress from '@material-ui/core/CircularProgress';

const MainLoadingIndicator = ({
    isLoading, 
    isSidebarOpen
}) => 
    isLoading ? (
        <Fragment>
            <div className={`headerLinkLoading${isLoading ? " pageIsLoading" : ""}`} />
            <div
                className={`mainLoadingIndicator${
                    isSidebarOpen ? " isSidebarOpen" : ""
                }`}
            >
                <CircularProgress
                    className={"progress"}
                    color="inherit"
                    size={80}
                    thickness={3}
                />
            </div>
        </Fragment>
    ) : null;

MainLoadingIndicator.propTypes = {
    isLoading: PropTypes.bool,
};

export default compose(
    connect(
        ( state, props ) => ({
            isLoading: state.main.loadingVersion > 0,
        })   
    )
)(MainLoadingIndicator);
